import { Table, Text, TextProps } from "@mantine/core";


interface TableErrorRowProps {
  colSpan: number;
  message: string;
  textProps?: TextProps;
}

export const TableErrorRow = ({
  colSpan,
  message,
  textProps = {},
}: TableErrorRowProps) => {
  return (
    <Table.Tr h={200}>
      <Table.Td colSpan={colSpan}>
        <Text fz={15} c="dimmed" lh={1.5} ta="center" {...textProps}>
          {message}
        </Text>
      </Table.Td>
    </Table.Tr>
  );
};
